import axios from "./axios";

const API_URL = axios.defaults.baseURL;
const BASE_URL = "/event";
const otherUrl = "/profiles"


export const CreateEventProfileApi = (payload) => {
    return axios.post(API_URL + BASE_URL + otherUrl, payload);
};

export const EditEventProfileApi = (profileId, payload) => {
    return axios.put(API_URL + BASE_URL + otherUrl + "/" + profileId, payload);
};

export const getEventProfiles = () => {
    return axios.get(API_URL + BASE_URL + otherUrl);
};

export const GetEventProfileById = (profileId) => {
    return axios.get(API_URL + BASE_URL + otherUrl + "/" + profileId);
}

export const deleteProfile = (profileID) => {
    return axios.delete(API_URL + BASE_URL + otherUrl + "/" + profileID);
};

export const configureSenderEmail = (profileId, payload) => {
    return axios.post(`${API_URL}${BASE_URL}${otherUrl}/${profileId}/sender-email`, payload);
};

export const getSenderEmail = (profileId) => {
    return axios.get(`${API_URL}${BASE_URL}${otherUrl}/${profileId}/sender-email`);
};

export const deleteSenderEmail = (profileId, emailId) => {
    return axios.delete(
        `${API_URL}${BASE_URL}${otherUrl}/${profileId}/sender-email`,
        { params: { email_id: emailId } }
    );
};
